import React from 'react';
import {motion} from 'framer-motion';

const Catering=()=> {
const services=[
 "Perfect for office meetings,private events,and celebrations",
 "Freshly baked baguettes,pastries,and handcrafted coffee",
 "Custom packages and local delivery available"
];

return (
<section className="py-20 px-6 bg-white">
<div className="max-w-6xl mx-auto">
<div className="grid md:grid-cols-2 gap-12 items-center">
<motion.div initial={{opacity: 0,x: -30}} whileInView={{opacity: 1,x: 0}} transition={{duration: 0.8}} viewport={{once: true}} className="space-y-6" >
<h2 className="text-4xl md:text-5xl font-playfair text-warm-brown mb-6"> We Cater Happiness </h2>
<h3 className="text-2xl font-playfair text-warm-brown/90 mb-4"> Catering by La Vie Saigon </h3>
<p className="text-xl text-warm-brown/80 mb-6 italic"> Bring a taste of Saigon to your next event. </p>
<ul className="space-y-4">
 {services.map((service,index)=> (
 <motion.li key={index} initial={{opacity: 0,x: -20}} whileInView={{opacity: 1,x: 0}} transition={{duration: 0.6,delay: index * 0.2}} viewport={{once: true}} className="flex items-start text-warm-brown/80 text-lg" >
 <span className="w-3 h-3 bg-gold-accent rounded-full mr-4 mt-2 flex-shrink-0"></span>
 {service}
 </motion.li>
 ))}
</ul>
<motion.div initial={{opacity: 0,y: 20}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.8,delay: 0.4}} viewport={{once: true}} className="pt-6" >
<button className="bg-warm-brown text-cream px-8 py-4 rounded-full text-lg font-medium hover:bg-warm-brown/90 transition-colors duration-300 shadow-lg"> Request a Catering Quote </button>
</motion.div>
</motion.div>
<motion.div initial={{opacity: 0,x: 30}} whileInView={{opacity: 1,x: 0}} transition={{duration: 0.8}} viewport={{once: true}} className="relative" >
<img src="https://cdn1.sharemyimage.com/smi/2025/10/27/Cater.png" alt="La Vie Saigon catering setup" className="rounded-lg shadow-2xl w-full h-96 object-cover" />
<div className="absolute inset-0 bg-gradient-to-t from-warm-brown/20 to-transparent rounded-lg"></div>
</motion.div>
</div>
</div>
</section>
);};
export default Catering;